import React from "react";
import { useRef } from "react";

export function DatePicker(
  props: Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "onFocus">
) {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <input
      ref={ref}
      type="date"
      onFocus={() => {
        if (ref.current) {
          ref.current.showPicker();
        }
      }}
      {...props}
    />
  );
}
